import React from 'react';
import {Row, Col, Grid} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import '../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '../styles/css/support.forum.post.css';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import {Description, ThreadPost} from '../components/Support.Forum.Post';
import uploadImageCallBack from '../util/uploadImageCallBack';
import {postThread} from '../actions/SupportAction';
import {connect} from 'react-redux';

class ForumPost extends React.Component{

  constructor(){
    super();
    this.state={
      title: null,
      category: '',
      author: null,
      editorState: EditorState.createEmpty(),
    };
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.postURL){
      this.props.history.push(nextProps.postURL);
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    let rawContents = convertToRaw(this.state.editorState.getCurrentContent());
    let contents = draftToHtml(rawContents);
    let contentsTest = rawContents.blocks.filter(val=>val.text.length>0);

    //!contents.replace(/<[^>]+>/gim,'')

    if(!this.state.title){
      alert('タイトルを入力してください');
      return;
    } else if(contentsTest.length===0){
      alert('内容を入力してください')
      return;
    }

    let thread = {
      thread:{
        name: this.state.title,
        contents: contents
      }
    }
    if(this.state.author){
      thread.thread.author = this.state.author;
    }

    this.props.postThread(thread);
  }

  onEditorStateChange(editorState){
    this.setState({
      editorState
    });
  }

  handleThreadInfoChange(event){
    this.setState({[event.target.name]: event.target.value});
  }

  render(){

    let handlers =
    {
      imageHandler: uploadImageCallBack,
      onEditorStateChange: this.onEditorStateChange.bind(this),
      onInfoChange: this.handleThreadInfoChange.bind(this),
    }

    return(
      <Grid className="forum-page">
        <Description />
        <ThreadPost handlers={handlers} state={this.state}/>
        <Row className="post-buttons">
          <Col xs={6} smOffset={2}>
            <button type="submit" id="post-btn" onClick={this.handleSubmit.bind(this)}>
              登録</button>
            <Link className="btn" type="Cancel" to="/forum" id="cancel-btn">キャンセル</Link>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state, props)=>{
  return{
    postURL: state.support.postURL
  }
}

const mapDispatchToProps = (dispatch)=>{
  return{
    postThread: (content) =>{
      dispatch(postThread(content));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForumPost);



// WEBPACK FOOTER //
// ./src/components/editorTest.js